import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80; // 80px offset for sticky header
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  const handleBooking = () => {
    window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer');
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="flex justify-between items-center" data-id="element-195">
          {/* Logo */}
          <a href="#inicio" onClick={e => handleNavClick(e, '#inicio')} className="flex items-center gap-2 group" data-id="element-196">
            <div className={`flex items-center justify-center w-10 h-10 rounded-full border transition-colors duration-300 ${isScrolled ? 'border-charcoal text-charcoal group-hover:border-rosegold group-hover:text-rosegold' : 'border-white text-white group-hover:border-rosegold group-hover:text-rosegold'}`} data-id="element-197">
              <span className="font-serif font-bold text-lg tracking-wider" data-id="element-198">
                SM
              </span>
            </div>
            <span className={`font-serif text-xl hidden sm:block transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-199">
              Studio by Mery
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-200">
            <ul className="flex gap-6" data-id="element-201">
              {navLinks.map(link => <li key={link.name} data-id="element-202">
                  <a href={link.href} onClick={e => handleNavClick(e, link.href)} className={`text-sm font-medium tracking-wide transition-colors duration-300 hover:text-rosegold ${isScrolled ? 'text-charcoal-light' : 'text-white/90'}`} data-id="element-203">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <button onClick={handleBooking} className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${isScrolled ? 'bg-rosegold text-white hover:bg-rosegold-dark shadow-sm hover:shadow' : 'bg-white text-charcoal hover:bg-rosegold hover:text-white'}`} data-id="element-204">
              Reservá tu turno
            </button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-205">
            {isMobileMenuOpen ? <X className={isScrolled ? 'text-charcoal' : 'text-white'} size={24} data-id="element-206" /> : <Menu className={isScrolled ? 'text-charcoal' : 'text-white'} size={24} data-id="element-207" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      <div className={`md:hidden absolute top-full left-0 w-full bg-cream shadow-lg transition-all duration-300 origin-top ${isMobileMenuOpen ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0'}`} data-id="element-208">
        <div className="px-4 pt-2 pb-6 space-y-4" data-id="element-209">
          <ul className="flex flex-col gap-4" data-id="element-210">
            {navLinks.map(link => <li key={link.name} data-id="element-211">
                <a href={link.href} onClick={e => handleNavClick(e, link.href)} className="block text-charcoal text-lg font-medium py-2 border-b border-cream-dark" data-id="element-212">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <button onClick={handleBooking} className="w-full mt-4 bg-rosegold text-white px-6 py-3 rounded-full text-base font-medium hover:bg-rosegold-dark transition-colors" data-id="element-213">
            Reservá tu turno
          </button>
        </div>
      </div>
    </header>;
}